import { __rest } from "tslib";
import { cnButton } from '../ButtonCn';
import './Button-Icon.css';
export var ButtonIcon = function (_a) {
    var side = _a.side, provider = _a.provider, props = __rest(_a, ["side", "provider"]);
    var className = cnButton('Icon', { side: side }, [props.className]);
    return provider(className);
};
